module.exports = __webpack_public_path__ + "img/703ec45.png";